import { useEffect, useState } from "react";

import { jwtDecode } from "jwt-decode";

import { DecodedInviteJWT } from "js/pages/Organization/types";

import { safeLocalStorage } from "@/utils/safeStorage";

export const useDecodeInviteToken = () => {
  const [decodedInviteJWT, setDecodedInviteJWT] = useState<DecodedInviteJWT>(
    {},
  );

  useEffect(() => {
    // MB-APP-EXPRESS-151 / -182: leer `window.localStorage` lanza SecurityError
    // en Edge/Windows con el almacenamiento bloqueado, y al estar dentro de un
    // useEffect el ErrorBoundary de App cambia /login y /signup completos por
    // "Algo salio mal". `safeLocalStorage` no lanza nunca.
    const inviteToken = safeLocalStorage.getItem("invite_token");

    if (!inviteToken) {
      return;
    }

    try {
      const decoded: DecodedInviteJWT = jwtDecode(inviteToken);
      setDecodedInviteJWT(decoded);
    } catch {
      // Un `invite_token` malformado (`?invite=basura`) hace que jwtDecode
      // lance InvalidTokenError en este mismo efecto y rompa /login y /signup
      // PARA SIEMPRE, porque el valor malo se queda guardado. Se descarta en
      // silencio: sin captureException, para no abrir un issue nuevo.
      safeLocalStorage.removeItem("invite_token");
    }
  }, []);

  return { decodedInviteJWT };
};
